// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k0O2","rootMobile":"styles_rootMobile__dp8Y4"};